import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ConsoleService {

  constructor() { }

  log(pre?: string, ...optionalParams: any): any {
    if (optionalParams === undefined || optionalParams.length === 0) {
      return function (...optionalParams: any) {
        if (pre !== undefined)
          console.log(`[${pre}]`, ...optionalParams)
        else
          console.log(...optionalParams)
      }
    } else {
      if (pre !== undefined)
        console.log(`[${pre}]`, ...optionalParams)
      else
        console.log(...optionalParams)
    }
  }

}
